import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Input = styled(TextField)(({ theme }) => ({
  '& .MuiFormLabel-root': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '120%',
    color: theme.customColors.black50,
  },
  '& .MuiInputBase-input': {
    padding: theme.spacing(2.5),
    // Убираем синий фон автозаполнения
    '&:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0 1000px ${theme.palette.common.white} inset`,
      WebkitTextFillColor: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      borderRadius: 'inherit',
    },
    '&:-webkit-autofill:hover': {
      WebkitBoxShadow: `0 0 0 1000px ${theme.palette.common.white} inset`,
    },
    '&:-webkit-autofill:focus': {
      WebkitBoxShadow: `0 0 0 1000px ${theme.palette.common.white} inset`,
    },
    '&:-webkit-autofill:active': {
      WebkitBoxShadow: `0 0 0 1000px ${theme.palette.common.white} inset`,
    },
  },
  '& .MuiInputBase-root': {
    color: theme.palette.text.primary, // Text color
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.primary, // Label color
    top: '-4px',
    '&.Mui-focused': {
      color: theme.palette.text.primary, // Focused label color
    },
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    '& fieldset': {
      borderColor: theme.customColors.primary10, // Default border color
    },
    '&:hover fieldset': {
      borderColor: theme.customColors.primary100, // Hover border color
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.customColors.primary100, // Focused border color
    },
  },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
}));
